import { EquipmentEventSeverities } from '../../core/openapi/bff-admin-api';
import { EquipmentEventLocalizationService } from '../services/equipment-event-localization.service';

export type EquipmentEventSeverityClass = 'normal' | 'warning' | 'critical';

export interface IEquipmentEventDescriptionSource {
  description?: string;
  severity?: string;
}

export const getEquipmentEventDescription = (
  eventLocalization: EquipmentEventLocalizationService,
  event: IEquipmentEventDescriptionSource | undefined,
): string => eventLocalization.getDescription(event?.description, event?.severity);

export const getEquipmentEventSeverityClass = (
  severity: string | undefined,
): EquipmentEventSeverityClass => {
  switch (severity) {
    case EquipmentEventSeverities.Warning:
      return 'warning';
    case EquipmentEventSeverities.Critical:
      return 'critical';
    case EquipmentEventSeverities.Normal:
    default:
      return 'normal';
  }
};
